import InformationFilled16 from '@carbon/icons-react/es/information--filled/16';
import styled from 'styled-components';

const Wrapper = styled.div<{ color: string }>`
  color: ${({ color }) => color ?? 'var(--blue-50)'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InformationIcon = ({
  color = 'var(--blue-50)',
}: {
  color?: string;
}): React.JSX.Element => {
  return (
    <Wrapper color={color}>
      <InformationFilled16 />
    </Wrapper>
  );
};
